import { circledCheckIcon } from 'components/icons'

export default {
  name: 'AddedButton',
  components: {
    circledCheckIcon
  },
  props: {
    label: {
      type: String
    },
  },
}